module.exports = __webpack_public_path__ + "img/user.3e932b91.svg";